import http from "@/helper/http";
import {BaseVO, GetByIdBO, PaginationVO} from "@/model/global";
import {useMutation, useQuery} from "@tanstack/react-query";
import {FilePO} from "@/model/content";
import {WriteFileForm} from "@/widget/UploadFile/WriteFile";
import {exportFile} from "@/helper/method";

export enum FileEnum {
    GetFilePage = "/file/getFilePage",
    GetFile = "/file/getFile",
    SaveFile = "/file/saveFile",
    DeleteFile = "/file/deleteFile",

}

export interface FilePageBO {
    keyword?: string;
    targetId?: number;
    current?: number
    size?: number
    tag?: number
}

export const useQueryFilePage = () => useMutation({
    mutationFn: (data: FilePageBO) => http.post<BaseVO<PaginationVO<FilePO>>>({
        url: FileEnum.GetFilePage,
        data: data,
    }),
})

export const useQueryFile = (params: GetByIdBO, enabled = true) => useQuery({
    queryKey: [params.id],
    queryFn: () => http.get<BaseVO<FilePO>>({url: FileEnum.GetFile, params}),
    enabled
});

export interface downloadFileBO {
    url: string;
    filename: string;
}

export const useSaveFile = () => useMutation({
    mutationFn: (data: WriteFileForm) => http.post({url: FileEnum.SaveFile, data}),
})

export const useDeleteFile = () => useMutation({
    mutationFn: (params: GetByIdBO) =>
        http.delete<BaseVO<null>>({url: FileEnum.DeleteFile, params})
})

export const downloadFile = (params: downloadFileBO) => {
    http.download(params).then((response) => {
        exportFile(response, params.filename)
    })
}

// export const useDownloadFile = () => useMutation({
//     mutationFn:  (params: any) => {
// const writer = createWriteStream(outputLocationPath);
// http.download(params).then(response => {
//     return new Promise((resolve, reject) => {
//         response.data.pipe(writer);
//         let error = null;
//         writer.on('error', err => {
//             error = err;
//             writer.close();
//             reject(err);
//         });
//         writer.on('close', () => {
//             if (!error) {
//                 resolve(true);
//             }
//             //no need to call the reject here, as it will have been called in the
//             //'error' stream;
//         });
//     });
// })
// const url = window.URL.createObjectURL(result.data);
// const link = document.createElement("a");
// link.style.display = "none";
// link.href = url;
// // link.setAttribute("download", fileName);
// document.body.appendChild(link);
// link.click();
// document.body.removeChild(link); // 下载完成移除元素
// window.URL.revokeObjectURL(url); // 释放掉blob对象
// }
// })


